/* -------------------------------------------------------------------------- */
/*                                   Roles                                    */
/* -------------------------------------------------------------------------- */

export enum ROLES {
	SUPERADMIN = 'SUPERADMIN',
	ADMIN = 'ADMIN',
	STAFF = 'STAFF',
	USER = 'USER',
	ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
	ORGANIZATION_STAFF = 'ORGANIZATION_STAFF',
	ORGANIZATION_MEMBER = 'ORGANIZATION_MEMBER',
	BRAND_ADMIN = 'BRAND_ADMIN',
	BRAND_STAFF = 'BRAND_STAFF',
	PRODUCER_ADMIN = 'PRODUCER_ADMIN',
	PRODUCER_STAFF = 'PRODUCER_STAFF',
	CLIENT_BRAND = 'CLIENT_BRAND',
	ANONYMOUS = 'ANONYMOUS',
}
